<template lang="pug">
app-page-layout
  a-spin.abs-fit.flex.align-center.justify-center(v-show="loading" style="z-index: 100;")
  div.detail-container.abs-fit
    a-card.mt1(:loading="modelLoading" :title="title" hoverable)
      //- div.p1.mb2(v-if="model.status === 'orderStatus_reject'" style="color: red;") 驳回理由: {{ model.rejectComments || '--'}}
      div.create-order
        app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="90")  
          div.title 商家信息
          a-row(:gutter="16")
            a-col(:sm="8")    
              a-form-model-item(label="商家" prop="vendorId" )
                div.p1(v-if="model.vendorDTO") {{ model.vendorDTO.name || '--' }}
              
            a-col(:sm="8")    
              a-form-model-item(label="品牌" prop="brandId" )
                div.p1(v-if="model.orderItems && model.orderItems[0] && model.orderItems[0].productDTO") {{ model.brandName || model.orderItems[0].productDTO.brandName || '--' }}
          a-row(:gutter="16")
            a-col(:sm="8")
              a-form-model-item(label="送货单编号" prop="supplyOrderCode" )
                div.p1 {{ model.supplyOrderCode || '--' }}
            a-col(:sm="8")    
              a-form-model-item(label="联系人" prop="customerName" )
                div.p1 {{ model.customerName || '--' }}
            a-col(:sm="8")    
              a-form-model-item(label="电话" prop="customerMobile" )
                div.p1 {{ model.customerMobile || '--' }}
          a-row(:gutter="16")
            a-col(:sm="8")    
              a-form-model-item(label="收货时间" prop="takeDeliveryTime" )
                div.p1 {{ model.takeDeliveryTime }}
            a-col(:sm="8")    
              a-form-model-item(label="签收人" prop="signedBy" )
                div.p1 {{ model.signedBy }}
          a-row(:gutter="16")
            a-col(:sm="8")    
              a-form-model-item(label="客户订单号" prop="customerOrderCode" )
                div.p1 {{ model.customerOrderCode }}
            a-col(:sm="8")    
              a-form-model-item(label="总数量" prop="totalQuantity" )
                div.p1 {{ model.totalQuantity }}
            a-col(:sm="8")    
              a-form-model-item(label="总分件数" prop="totalParts" )
                div.p1 {{ model.totalParts }}
          div.title.flex 产品列表
          div 
            a-form-model-item(label="" prop="orderItems" )
              ProductDTOSDetails(:value="model.orderItems" :productDTOS="model.orderItems" :target="model" detailMode)


          div.title 订单图片
          div 
            a-form-model-item(label="" prop="fileIds" )
              app-imgs-display(:files="model.fileDTOS")


          div.title 备注          
          a-row(:gutter="16")
            a-col(:sm="24")                    
              a-form-model-item(label="备注信息" prop="keeperComments" )
                div.p1 {{ model.keeperComments || '--' }}
          

      //- div.footer.flex      
        a-button.ml2(type="primary" :loading="loading" @click="handleSave()") 保存       
        a-button.ml2(type="primary" :loading="loading" @click="handleSubmit()") 入库       
        
</template>

<script>
import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
import ProductDTOSDetails from './Modal/ProductDTOSDetails';
// import Actions from './Components/Actions/index';
import moment from 'moment';
export default {
  name: 'CreateAndEdit',
  components: {
    ProductDTOSDetails,
    // Actions,
  },
  data() {
    return {
      modelLoading: false,
      visible: false,
      loading: false,
      title: '供货入库单详情',
      // 送货单编号 supplyOrderCode   客户订单号 customerOrderCode    签收人 signedBy
      // 收货时间 takeDeliveryTime  总分件数 totalParts   总数量 totalQuantity
      // 联系人 customerName 联系电话 customerMobile 备注 keeperComments
      model: {
        vendorId: null,
        vendorMobile: null,
        vendorAddress: null,
        brandId: null,
        stockType: 'stockType_instock',
        stockSubType: 'instockType_supply',

        supplyOrderCode: null,
        customerOrderCode: null,
        signedBy: null,
        takeDeliveryTime: moment().format('YYYY-MM-DD HH:mm:ss'),

        totalParts: 0,
        totalQuantity: 0,

        customerName: null,
        customerMobile: null,
        customerAddress: null,

        keeperComments: null,

        orderItems: [],
        productDTOS: [],

        fileIds: [],
        fileDTOS: [],
      },
      rules: {},
      //
      vendorList: [],
      // 禁用日志
      disabledDays: [],
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
    params2() {
      return {
        projectId: this.project.id,
        vendorId: this.model.vendorId,
      };
    },
    id() {
      return this.$route.params.id;
    },
  },
  created() {
    this.laodModel();
  },
  methods: {
    laodModel() {
      this.modelLoading = true;
      this.$restful(`GET:/prj/orders/${this.id}`)
        .then((res) => {
          this.model = {
            ...res,
            productDTOS: res?.orderItems?.map((item) => item.productDTO) || [],
          };
          // console.log(this.model, '==============');
          this.handleOrderItemsChange();
        })
        .then(() => {
          this.modelLoading = false;
        });
    },

    // 产品列表修改
    handleOrderItemsChange() {
      let totalParts = 0;
      let totalQuantity = 0;
      this.model.orderItems.forEach((item) => {
        totalParts += item.quantity * (item?.productDTO?.parts || 1);
        totalQuantity += item?.quantity || 1;
      });
      this.model.totalParts = totalParts;
      this.model.totalQuantity = totalQuantity;
    },
  },
};
</script>

<style lang="less" scoped>
.detail-container {
  height: 100%;
  padding: 20px;
  overflow: auto;
  .detail-content {
    height: 100%;
    background-color: #fff;
    overflow: auto;
  }
}
.create-order {
  //
}
.title {
  padding: 2px 12px;
  border-left: 4px solid #1890ff;
  margin-bottom: 12px;
}
</style>
